import { FinalizePackageResponse } from "redmond";
import * as actionTypes from "./constants";

export interface IFinalizePackage {
  type: actionTypes.FINALIZE_PACKAGE;
  versionPollTarget?: number;
  useV2?: boolean;
}

export const finalizePackage = (
  versionPollTarget?: number,
  useV2?: boolean
): IFinalizePackage => ({
  type: actionTypes.FINALIZE_PACKAGE,
  versionPollTarget,
  useV2,
});

export interface ISetFinalizePackageResponse {
  type: actionTypes.SET_FINALIZE_PACKAGE_RESPONSE;
  finalizeResponse: FinalizePackageResponse;
}

export const setFinalizePackageResponse = (
  tripDetailsResponse: FinalizePackageResponse
): ISetFinalizePackageResponse => ({
  type: actionTypes.SET_FINALIZE_PACKAGE_RESPONSE,
  finalizeResponse: tripDetailsResponse,
});

export interface ISetFinalizePackageResponseCallStateFailed {
  type: actionTypes.SET_FINALIZE_PACKAGE_RESPONSE_CALL_STATE_FAILED;
  finalizePackageCallError: unknown;
}

export const setFinalizePackageResponseCallStateFailed = (
  finalizePackageCallError: unknown
): ISetFinalizePackageResponseCallStateFailed => ({
  type: actionTypes.SET_FINALIZE_PACKAGE_RESPONSE_CALL_STATE_FAILED,
  finalizePackageCallError,
});

export type PackageItineraryReviewActions =
  | IFinalizePackage
  | ISetFinalizePackageResponse
  | ISetFinalizePackageResponseCallStateFailed;
